var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOperationModel(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.14 11.5C18.18 11.17 18.2 10.84 18.2 10.5C18.2 10.16 18.18 9.83 18.14 9.5L20.18 7.93C20.36 7.79 20.41 7.53 20.3 7.33L18.36 3.97C18.24 3.77 17.99 3.69 17.78 3.77L15.36 4.74C14.82 4.33 14.23 3.99 13.59 3.73L13.23 1.13C13.2 0.9 13 0.73 12.76 0.73H8.88C8.64 0.73 8.44 0.9 8.41 1.13L8.05 3.73C7.41 3.99 6.82 4.33 6.28 4.74L3.86 3.77C3.65 3.69 3.4 3.77 3.28 3.97L1.34 7.33C1.22 7.53 1.28 7.79 1.46 7.93L3.5 9.5C3.46 9.83 3.44 10.16 3.44 10.5C3.44 10.84 3.46 11.17 3.5 11.5L1.46 13.07C1.28 13.21 1.22 13.47 1.34 13.67L3.28 17.03C3.4 17.23 3.65 17.31 3.86 17.23L6.28 16.26C6.82 16.67 7.41 17.01 8.05 17.27L8.41 19.87C8.44 20.1 8.64 20.27 8.88 20.27H12.76C13 20.27 13.2 20.1 13.23 19.87L13.59 17.27C14.23 17.01 14.82 16.67 15.36 16.26L17.78 17.23C17.99 17.31 18.24 17.23 18.36 17.03L20.3 13.67C20.42 13.47 20.36 13.21 20.18 13.07L18.14 11.5ZM10.82 14C8.89 14 7.32 12.43 7.32 10.5C7.32 8.57 8.89 7 10.82 7C12.75 7 14.32 8.57 14.32 10.5C14.32 12.43 12.75 14 10.82 14Z",
    fill: "#646C77"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOperationModel);
export default __webpack_public_path__ + "static/media/ic_operation_model.3dc32258b387070f907d9d6a83628ed7.svg";
export { ForwardRef as ReactComponent };